import React from 'react';
import { companyInfo } from '../styles/variables';
import aboutImg from '../images/about.jpg';

const stats = [
  { num: '20+', label: 'Years Active' },
  { num: '50+', label: 'Export Markets' },
  { num: '100%', label: 'Quality Assured' },
];

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-grid">

          {/* Visual Left */}
          <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                flex: 1,
                borderRadius: 'var(--radius-xl)',
                overflow: 'hidden',
                boxShadow: 'var(--shadow-xl)',
                minHeight: '600px',
              }}
            >
              <img
                src={aboutImg}
                alt="Swiss N Scott Production Facility"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                  display: 'block',
                }}
              />
            </div>
            <div className="about-badge">
              <div className="about-badge-num">20+</div>
              <div className="about-badge-text">Years<br />Export<br />Experience</div>
            </div>
          </div>

          {/* Content Right */}
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div className="intro-eyebrow">Our Story</div>

            <h2
              className="intro-title"
              style={{
                fontSize: 'clamp(2.4rem, 3.5vw, 3.6rem)',
                marginBottom: '1.75rem',
                color: 'var(--color-black)',
                lineHeight: 1.1,
              }}
            >
              Manufacturing <em>Excellence</em><br />Since 2004
            </h2>

            <p className="about-text">
              <strong>Swiss N Scott</strong> is a manufacturer & exporter of kitchen towels and home
              textile products. We have been exporting from <strong>Multan, Pakistan</strong> to
              European and USA markets since 2004.
            </p>

            <p className="about-text">
              We have our own high-capacity production house and vast experience in manufacturing
              quality goods within required delivery timelines. Our commitment to excellence has
              built lasting partnerships with retailers and distributors across Europe and North America.
            </p>

            <p className="about-text">
              Our experienced team manages the full production cycle — from <strong>dyeing</strong> to
              weaving, finishing, quality inspection, and <strong>carton packing</strong> — ensuring
              that every product leaving our facility meets international standards.
            </p>

            {/* Stats Row */}
            <div
              style={{
                display: 'flex',
                margin: '2rem 0',
                border: '1px solid var(--color-border)',
                borderRadius: 'var(--radius-lg)',
                overflow: 'hidden',
                background: 'var(--color-beige-light)',
              }}
            >
              {stats.map((s, i) => (
                <div
                  key={s.num}
                  style={{
                    flex: 1,
                    padding: '1.5rem 1rem',
                    textAlign: 'center',
                    borderRight: i < stats.length - 1 ? '1px solid var(--color-border)' : 'none',
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'var(--font-heading)',
                      fontSize: '2.4rem',
                      fontWeight: 600,
                      color: 'var(--color-gold-dark)',
                      lineHeight: 1,
                      marginBottom: '0.4rem',
                    }}
                  >
                    {s.num}
                  </div>
                  <div
                    style={{
                      fontFamily: 'var(--font-accent)',
                      fontSize: '0.6rem',
                      letterSpacing: '0.15em',
                      textTransform: 'uppercase',
                      color: 'var(--color-mid-grey)',
                    }}
                  >
                    {s.label}
                  </div>
                </div>
              ))}
            </div>

            {/* Certifications */}
            <div className="about-certs">
              <div className="about-certs-title">Our Certifications</div>
              <div className="about-certs-grid">
                {companyInfo.certifications.map((cert) => (
                  <div key={cert} className="about-cert">{cert}</div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;